import { render } from "./DefaultProfile.vue?vue&type=template&id=d958f0da"
import script from "./DefaultProfile.vue?vue&type=script&lang=js"
export * from "./DefaultProfile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__